import { FilterData as RoutesFilterData } from "@/pages/RoutesFlights/components/FilterBar/typing";
import { createLocalStorageOnce } from "@/utils/createLocalStorageOnce";

export const alertPanoramaFilterStorage =
  createLocalStorageOnce<RoutesFilterData>("alert-panorama-filter");
